import {
  APIError,
  DEFAULT_API_URL,
  ErrorMessage,
  FetchParams,
  customFetch,
} from '../../common';

export const subscribeToNotifications = async ({
  fetchFn,
  params,
}: {
  fetchFn: typeof fetch;
  params: NotifyMe.Notification & FetchParams;
}): Promise<NotifyMe.PathNotifymeNotificationsv1PostResponse> => {
  const { fetchParams: { baseUrl = DEFAULT_API_URL, timeout } = {}, ...body } =
    params;
  const path = 'targeted_marketing/notifyme_notifications/v1';
  const url = `${baseUrl}/${path}`;
  const requestOptions = {
    body: JSON.stringify(body),
    headers: {
      'Content-type': 'application/json',
    },
    method: 'POST',
    path,
    timeout,
  };

  const result = await customFetch({
    fetchFn,
    options: requestOptions,
    url,
  });
  try {
    return await result.json();
  } catch (e) {
    throw new APIError(ErrorMessage.JSON_PARSE, {
      originalMessage: e.message,
      requestBody: JSON.parse(requestOptions.body),
      requestOptions,
      url,
    });
  }
};
